import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputGroupContext = /*#__PURE__*/createContext(undefined);
export const InputGroupProvider = ({
  fieldsetStylesOverrides = {},
  selectStylesOverrides = {},
  children
}) => {
  return /*#__PURE__*/_jsx(InputGroupContext.Provider, {
    value: {
      fieldsetStylesOverrides,
      selectStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `InputGroup` component.
 * Note: The context is only available when the `InputGroup` component is rendered as an ancestor.
 * @returns InputGroupContext - The context for the `InputGroup` component.
 * @returns InputGroupContext.fieldsetStylesOverrides - Style overrides to be applied to the `Fieldset` component.
 * @returns InputGroupContext.selectStylesOverrides - Style overrides to be applied to the `Select` component.
 */
export const useInputGroupContext = () => {
  const inputGroupContext = useContext(InputGroupContext);
  return inputGroupContext;
};